export const SaveKeySearch = async (
  SeachInput: any,
  setSearchInput?: any,
  type?: number
) => {
  // Lưu ý : type = 1 : dành cho loại dùng form
  // type = 2 : dành cho loại dùng onchange
  try {
    const storedData = JSON.parse(
      localStorage.getItem("allValueKeySearch") || "{}"
    );
    // console.log("storedData", storedData);
    // Lấy các keys của storedData và search
    const storedKeys = Object.keys(storedData); //Note : Objectkey để chuyển thành mảng
    const searchKeys = Object.keys({
      ...(type === 1 ? SeachInput.getValues() : SeachInput),
      url: String(window.location.pathname),
    });
    // console.log("storedKeys", storedKeys);
    // console.log("searchKeys", searchKeys);
    //chỗ này để kiểm tra xem dữ liệu của nó có trùng nhau không
    const isSameKey =
      storedData.url === window.location.pathname &&
      storedKeys.length === searchKeys.length &&
      searchKeys.every((key) => searchKeys.includes(key));
    console.log("isSameKey", isSameKey);
    if (isSameKey && storedData) {
      if (type === 1) {
        SeachInput.setValues({
          // cho form
          ...storedData,
        });
      } else if (type === 2) {
        setSearchInput((prev: any) => ({
          //cho onchangeState
          ...prev,
          ...storedData,
        }));
        return storedData;
      } else {
        return;
      }
    } else {
      //   console.log("không có dữ liệu trong storedData");
      localStorage.setItem(
        "allValueKeySearch",
        JSON.stringify({
          url: String(window.location.pathname),
        })
      );
    }
  } catch (error) {
    console.error("Error parsing search data:", error);
  }
};
export const saveKeySearchOnChange = async (key: string, value: any) => {
  try {
    const storedData = JSON.parse(
      localStorage.getItem("allValueKeySearch") || "{}"
    );

    const isSameKey =
      storedData.url === window.location.pathname && storedData[key] === value;

    if (isSameKey) return;

    localStorage.setItem(
      "allValueKeySearch",
      JSON.stringify({
        ...storedData,
        [key]: value,
        url: window.location.pathname,
      })
    );
  } catch (error) {
    console.error("Error saving search data:", error);
  }
};
